import { render } from "./BrandLigaportal.vue?vue&type=template&id=15782a0a"
import script from "./BrandLigaportal.vue?vue&type=script&lang=ts"
export * from "./BrandLigaportal.vue?vue&type=script&lang=ts"

import "./BrandLigaportal.vue?vue&type=style&index=0&id=15782a0a&lang=scss"
script.render = render

export default script